var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarManifest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2860_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 19.1875C16.2081 19.1875 17.1875 18.2081 17.1875 17C17.1875 15.7919 16.2081 14.8125 15 14.8125C13.7919 14.8125 12.8125 15.7919 12.8125 17C12.8125 18.2081 13.7919 19.1875 15 19.1875Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2655 19.743C10.0238 19.3267 9.83862 18.88 9.71484 18.4147L10.6325 17.2663C10.6221 17.0907 10.6221 16.9146 10.6325 16.7391L9.71539 15.5906C9.83895 15.1253 10.0238 14.6784 10.265 14.2617L11.7257 14.0977C11.8423 13.9662 11.9667 13.8419 12.0981 13.7252L12.2622 12.2651C12.6783 12.025 13.1244 11.8413 13.5889 11.7188L14.7373 12.6364C14.9129 12.626 15.089 12.626 15.2645 12.6364L16.413 11.7193C16.8783 11.8429 17.3252 12.0277 17.7419 12.2689L17.9059 13.7296C18.0374 13.8463 18.1617 13.9706 18.2784 14.102L19.7385 14.2661C19.9802 14.6825 20.1654 15.1292 20.2892 15.5945L19.3716 16.7429C19.382 16.9185 19.382 17.0945 19.3716 17.2701L20.2887 18.4185C20.166 18.8837 19.9821 19.3306 19.7418 19.7474L18.2811 19.9115C18.1644 20.0429 18.0401 20.1673 17.9087 20.2839L17.7446 21.7441C17.3282 21.9858 16.8815 22.171 16.4162 22.2948L15.2678 21.3771C15.0922 21.3875 14.9162 21.3875 14.7406 21.3771L13.5922 22.2942C13.127 22.1715 12.6801 21.9876 12.2633 21.7473L12.0992 20.2866C11.9678 20.17 11.8434 20.0456 11.7268 19.9142L10.2655 19.743Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5V8.25L12.625 4H3.875C3.64294 4 3.42038 4.08955 3.25628 4.24896C3.09219 4.40837 3 4.62457 3 4.85V20.15C3 20.3754 3.09219 20.5916 3.25628 20.751C3.42038 20.9104 3.64294 21 3.875 21H11.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4V9.25H17",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2860_1157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "var(--bg-surface)",
    transform: "translate(8 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarManifest);
export default __webpack_public_path__ + "static/media/sidebarManifest.3d2aef9079be0aac90efa2781448820b.svg";
export { ForwardRef as ReactComponent };